<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import Withdraw from './Withdraw/index.vue'
import { bus as layoutBus } from '@/layouts/default.vue'

const emit = defineEmits(['close'])

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')

const user = useUser()
const userStripeAccount = useUserStripeAccount()
const featureFlags = useFeatureFlags()

function logOut() {
  useFirebaseAuth().logOut()
  emit('close')
}
</script>

<template>
  <AppFloatingMenu w-max min-w="200px" max-w="280px" space-y-2 relative max-height="none" z-999>
    <div v-if="user" flex items-center gap-2 pt-3 px-3>
      <img
        :src="optimizeImage(user.avatar, {
          width: 24 * 2,
          height: 24 * 2,
        })"
        :alt="user.name"
        :title="user.name"
        w-6 h-6 rounded-full object-cover object-center
      >
      <Heading level="4">
        {{ user.name }}
      </Heading>
    </div>

    <div v-if="userStripeAccount && userStripeAccount?.state !== 'no account'" px-3 pt="3 md:2" w-full max-w="100vw">
      <AppHeaderSellerProfileBanner v-if="userStripeAccount.state === 'restricted'" />
      <Withdraw v-else />
    </div>

    <ul pb-2>
      <NuxtLink v-if="user" :to="`/${user.username}`">
        <AppFloatingMenuItem gap-2 justify-start px-3 text-soft-black>
          <div i-material-symbols:account-circle class="mr-1 w-3.5 h-3.5" />
          Profile
        </AppFloatingMenuItem>
      </NuxtLink>

      <NuxtLink v-if="user && featureFlags.teams?.enable" to="/my-teams">
        <AppFloatingMenuItem gap-2 justify-start px-3 text-soft-black>
          <div i-material-symbols:supervisor-account-outline-sharp class="mr-1 w-3.5 h-3.5" />
          My Teams
        </AppFloatingMenuItem>
      </NuxtLink>

      <NuxtLink v-if="user && featureFlags.apiKeys?.enable" to="/api-keys">
        <AppFloatingMenuItem gap-2 justify-start px-3 text-soft-black>
          <div i-material-symbols:lock class="mr-1 w-3.5 h-3.5" />
          API Keys
        </AppFloatingMenuItem>
      </NuxtLink>

      <AppFloatingMenuItem v-if="isMobile" gap-2 justify-start px-3 text-soft-black @click="layoutBus.emit('toggle-saved')">
        <div i-material-symbols:bookmark-outline-rounded class="mr-1" />
        Saved
      </AppFloatingMenuItem>

      <NuxtLink v-if="user" :to="`/${user.username}/edit`">
        <AppFloatingMenuItem gap-2 justify-start px-3 text-soft-black>
          <div i-tabler:settings class="transform rotate-90 mr-1" />
          Settings
        </AppFloatingMenuItem>
      </NuxtLink>

      <AppFloatingMenuItem gap-2 justify-start px-3 text-soft-black @click="logOut">
        <div i-material-symbols-logout-rounded class="mr-1" />
        Logout
      </AppFloatingMenuItem>
    </ul>
  </AppFloatingMenu>
</template>
